// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import settingsReducer from "../features/settings/settingsSlice";
import summaryReducer from "../features/summary/summarySlice";
import teamReducer from "../features/team/teamSlice";
import activityReducer from "../features/activity/activitySlice";
import cleanReducer from "../features/clean/cleanSlice";

const store = configureStore({
  reducer: {
    settings: settingsReducer,
    summary: summaryReducer,
    team: teamReducer,
    activity: activityReducer,
    cleans: cleanReducer,
  },
});

export default store;
